module.exports = __webpack_public_path__ + "static/media/Two_Hand_D.ce100a17.png";